<template>
    <div id="app">
        <div :class="[windowLoaded && !loadingConfig ? 'done' : '']" class="preloader">
            <div class="left"></div>
            <div class="right"></div>
            <div class="spinner">
                <b-spinner label="Loading..."></b-spinner>
                <h3>Ładowanie ...</h3>
            </div>
        </div>
        <RouterView v-if="!loadingConfig && isConfig"/>
        <div v-else class="d-flex justify-content-center align-items-center text-center" style="min-height: 100vh">
            <h2 class="text-danger"><i class="text-danger fa fa-exclamation-triangle"></i> Niestety nie mogliśmy pobrać configu. <br>Upewnij się, że panel jest włączony</h2>
        </div>
    </div>
</template>

<script>
import appConfig from "@/app.config";

import {notificationMethods} from "@/state/helpers";
import Vue from 'vue';
import ConfigService from "@/services/config.service";

export default {
    name: "app",
    page: {
        // All subcomponent titles will be injected into this template.
        titleTemplate(title) {
            title = typeof title === "function" ? title(this.$store) : title;
            return title ? `${title} | ${appConfig.title}` : appConfig.title;
        }
    },
    data() {
        return {
            windowLoaded: false,
            loadingConfig: true,
        }
    },
    computed: {
        loggedIn() {
            return this.$store.getters['auth/loggedIn'];
        },
        notification() {
            return this.$store.state.notification;
        },
        isOnline() {
            return this.$store.getters['auth/user']?.isOnline;
        },
        isConfig() {
            return !!this.$store.getters['cfg/get'];
        }
    },
    async mounted() {
      window.addEventListener("load", () => {
        document.body.classList.add("loaded");
        this.windowLoaded = true
      });

        await this.loadConfig();

        this.checkAuthAndRefresh();
    },
    watch: {
        notification: {
            handler() {
                if (this.notification.type) {
                    Vue.swal.fire({
                        title: this.notification.message,
                        toast: true,
                        icon: this.notification.type,
                        showConfirmButton: false,
                        position: 'top-end',
                        timer: 3000
                    });
                    this.clearNotification();
                }
            },
            deep: true
        },
        loggedIn() {
            this.checkAuthAndRefresh();
        },
        /**
         * Clear the alert message on route change
         */
        // eslint-disable-next-line no-unused-vars
        $route(to, from) {
            // clear alert on location change
            //this.clearNotification();
        },
    },
    methods: {
        ...notificationMethods,
        clearNotification: notificationMethods.clear,
        async loadConfig() {
            return new Promise((resolve, reject) => {
                ConfigService.getConfig().then(
                    response => {
                        this.$store.dispatch('cfg/setConfig', response.data);
                        this.loadingConfig = false;
                        resolve(true);
                    },
                    error => {
                        this.loadingConfig = false;
                        console.log(error)
                        reject(error);
                    }
                );
            });
        },
        checkAuthAndRefresh() {
            if (this.loggedIn)
                this.refreshClientInfo();
        },
        refreshClientInfo() {
            if (!this.loggedIn)
                return;

            this.$store.dispatch('auth/refreshClientInfo').then(
                () => {
                    setTimeout(this.refreshClientInfo, 3000)
                },
                error => {
                    console.log("Error occurred, retrying in 5 seconds", error);
                    setTimeout(this.refreshClientInfo, 5000)
                }
            );
        }
    }
};
</script>
